import React from "react";
import MuiTable from "@mui/material/Table";
import PropTypes from "prop-types";

/**
 * Table component wrapper for displaying tabular data.
 * Wraps Material-UI Table with theme integration.
 * 
 * @component
 * @example
 * <Table>
 *   <TableHead>
 *     <TableRow>
 *       <TableCell>Name</TableCell>
 *     </TableRow>
 *   </TableHead>
 *   <TableBody>
 *     <TableRow>
 *       <TableCell>John Doe</TableCell>
 *     </TableRow>
 *   </TableBody>
 * </Table>
 */
const Table = ({ children, ...props }) => {
  return <MuiTable {...props}>{children}</MuiTable>;
};

Table.propTypes = {
  /**
   * The content of the table, normally TableHead and TableBody
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Allows TableCells to inherit padding of the Table
   */
  padding: PropTypes.oneOf(["normal", "checkbox", "none"]),
  /**
   * Allows TableCells to inherit size of the Table
   */
  size: PropTypes.oneOf(["small", "medium"]),
  /**
   * Set the header sticky
   */
  stickyHeader: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Table behavior
// MUI Table defaults: padding="normal", size="medium"

export default Table;

